<template>

  <section id="loginPage">
    <vue-particles
    color="#800000"
    :particleOpacity="0.5"
    :particlesNumber="200"
    shapeType="star"
    :particleSize="6"
    linesColor="#00acd6"
    :linesWidth="1"
    :lineLinked="true"
    :lineOpacity="0.4"
    :linesDistance="100"
    :moveSpeed="6"
    :hoverEffect="true"
    hoverMode="grab"
    :clickEffect="true"
    clickMode="repulse"
>
</vue-particles>
    <div id="login">
      <div class="container">
        <div id="login-row" class="row justify-content-center align-items-center">
          <div id="login-column" class="col-md-6">
            <div id="login-box" class="col-md-12">
              <form id="login-form" class="form" v-on:submit.prevent="login()">
                <h2 class="text-center text-info">Login</h2><br>
                <label for="email" class="text-info textLabel">Email:</label>
                <br />
                <div class="control has-icons-left">
                  <input
                    type="text"
                    name="email"
                    id="email"
                    class="input is-rounded"
                    placeholder="input your email here"
                    v-model="email"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-envelope"></i>
                  </span>
                </div>
                <br>
                <label for="password" class="text-info textLabel">Password:</label>
                <br />
                <div class="control has-icons-left">
                  <input
                    type="password"
                    name="password"
                    id="password"
                    placeholder="input your password here"
                    class="input is-rounded"
                    v-model="password"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                </div>
                <br />

                <input
                  type="submit"
                  name="submit"
                  class="button is-primary is-fullwidth"
                  value="LogIn"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login () {
      let payload ={
        email: this.email,
        password: this.password
      }
      this.$store.dispatch('login',payload)
    }
  },
  created () {
    if(this.$store.state.isLogin){
      this.$router.push({name: 'AllProduct'})
    }
  }

}
</script>

<style>


.textLabel{
  float: left;
}
#login .container #login-row #login-column #login-box {
  margin-top: 50px;
  max-width: 600px;
  height: 320px;

  border-radius: 5%;
  border: 1px solid #9c9c9c;
  background-color: #eaeaea;
  margin-bottom: 120px;
}
#login .container #login-row #login-column #login-box #login-form {
  padding: 20px;
}
#login{
z-index: 999;
background: url('https://image.freepik.com/free-vector/asian-market-flat-cartoon-concept-illustration-arabic-bazaar-old-eastern-city-background_212168-12.jpg') no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
#particles-js{
  width: 100%;
  position: fixed;
  z-index: 0;
  height: 100%;
}

</style>
